
import {SaseungHanjaService} from "./saseung-hanja.service";

export const SaseungHanjaInjectables: Array<any> = [
  {
    provide: SaseungHanjaService,
    useClass: SaseungHanjaService,
  },
];
